import { render } from "./FilePreviewModal.vue?vue&type=template&id=d78da6e6"
import script from "./FilePreviewModal.vue?vue&type=script&lang=js"
export * from "./FilePreviewModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__